import React, { useRef, useEffect } from 'react';

const DynamicProgressBar = ({ paramValue, paramSize, paramThickness, barColor,storkeColor }) => {

    const drawCircularProgress = (ctx, value, size, thickness, color,storkeColor) => {
        if (!isFinite(value) || !isFinite(size) || !isFinite(thickness)) {
            console.error('One of the parameters is not a finite number');
            return;
        }

        const radius = (size - thickness) / 2;
        const center = size / 2;
        const startAngle = -Math.PI / 2;
        const endAngle = startAngle + (Math.PI * 2 * (value / 100));

        ctx.clearRect(0, 0, size, size);

        // Draw background circle
        ctx.beginPath();
        ctx.arc(center, center, radius, 0, Math.PI * 2);
        ctx.lineWidth = thickness;
        ctx.strokeStyle = storkeColor ? `${storkeColor}20` :  '#f0f0f0';
        ctx.stroke();

        // Draw progress with the passed color
        ctx.beginPath();
        ctx.arc(center, center, radius, startAngle, endAngle);
        ctx.lineWidth = thickness;
        ctx.strokeStyle = color;
        ctx.stroke();
    };

    const CircularProgressCanvas = ({ value, size, thickness, color, storkeColor }) => {
        const canvasRef = useRef(null);

        useEffect(() => {
            const canvas = canvasRef.current;
            const ctx = canvas.getContext('2d');
            drawCircularProgress(ctx, value, size, thickness, color, storkeColor);
        }, [value, size, thickness, color]);

        return <canvas ref={canvasRef} width={size} height={size} />;
    };

    return (
        <CircularProgressCanvas value={paramValue} size={paramSize} thickness={paramThickness} color={barColor} storkeColor={storkeColor}  />
    );
}

export default DynamicProgressBar;
